var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagSouthKorea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5659 16C21.5659 17.3913 19.0743 20.8696 16.0007 20.8696C12.9272 20.8696 10.4355 17.3913 10.4355 16C10.4355 12.9264 12.9272 10.4348 16.0007 10.4348C19.0743 10.4348 21.5659 12.9264 21.5659 16Z",
    fill: "#D80027"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5659 16C21.5659 19.0736 19.0743 21.5652 16.0007 21.5652C12.9272 21.5652 10.4355 19.0736 10.4355 16",
    fill: "#0052B4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8984 20.9193L23.3739 19.4438L24.3576 20.4274L22.8821 21.9029L21.8984 20.9193Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4395 23.3784L20.9149 21.903L21.8986 22.8866L20.4231 24.3621L19.4395 23.3784Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8496 23.8701L26.3251 22.3946L27.3087 23.3782L25.8333 24.8537L24.8496 23.8701Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3906 26.3297L23.8661 24.8542L24.8497 25.8378L23.3743 27.3133L22.3906 26.3297Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.373 22.3948L24.8485 20.9193L25.8322 21.903L24.3567 23.3784L23.373 22.3948Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9141 24.8539L22.3895 23.3785L23.3732 24.3621L21.8977 25.8376L20.9141 24.8539Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8555 11.0835L20.9209 7.14886L21.9045 6.1652L25.8391 10.0998L24.8555 11.0835Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9199 10.1002L19.4445 8.62474L20.4281 7.64113L21.9035 9.11659L20.9199 10.1002Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3809 12.5599L21.9054 11.0845L22.889 10.1008L24.3645 11.5763L23.3809 12.5599Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8711 7.14873L22.3956 5.67326L23.3793 4.68961L24.8548 6.16507L23.8711 7.14873Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M26.332 9.60876L24.8566 8.1333L25.8402 7.14964L27.3157 8.62511L26.332 9.60876Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M5.67188 22.392L9.60646 26.3266L8.6228 27.3102L4.68822 23.3757L5.67188 22.392Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M9.60742 23.3749L11.0829 24.8503L10.0993 25.834L8.62381 24.3585L9.60742 23.3749Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M7.14648 20.9162L8.62195 22.3917L7.63829 23.3754L6.16283 21.8999L7.14648 20.9162Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M8.62305 19.4403L12.5576 23.3749L11.574 24.3586L7.63939 20.424L8.62305 19.4403Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M9.60547 5.67023L5.67088 9.60481L4.68723 8.62116L8.62181 4.68657L9.60547 5.67023Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M11.082 7.14552L7.14744 11.0801L6.16378 10.0965L10.0984 6.16187L11.082 7.14552Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5586 8.62189L8.62401 12.5565L7.64039 11.5729L11.575 7.63827L12.5586 8.62189Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagSouthKorea);
export default __webpack_public_path__ + "static/media/flagSouthKorea.6dd0685d3e79ffd0b6401d01a6b3014b.svg";
export { ForwardRef as ReactComponent };